import React, { FC } from 'react';
import { useContract, useNFT } from '@thirdweb-dev/react';
import { useAsync } from 'react-use';
import { AspectRatio, Box, HStack, Text } from '@chakra-ui/react';
import { useRewardNftsMarketplaceFiltersState } from '@app/state/rewardsNftsMarketplaceFiltersStore';
import { formatUSD } from '@app/helpers/formatUSD';

interface Props {
  contractAddress: string;
}

export const FeaturedCollection: FC<Props> = ({ contractAddress }) => {
  const {
    collection,
    floorPrices,
    actions: { setCollection }
  } = useRewardNftsMarketplaceFiltersState();
  const { contract } = useContract(
    contractAddress?.toLowerCase() ?? ''
    // 'nft-collection'
  );

  const floorPrice = floorPrices[contractAddress.toLowerCase()] ?? 0;

  const { data } = useNFT(contract, 0);

  const { value: name } = useAsync(async () => {
    if (!contract) {
      return;
    }

    return await contract.call('name');
  }, [contract]);

  const isSelected = collection === contractAddress;

  if (!data) {
    return null;
  }

  return (
    <Box
      sx={{
        border: '1px solid',
        borderColor: isSelected ? 'orange' : 'neutral.700',
        borderRadius: '8px',
        padding: '12px 12px 8px',
        width: 'fit-content',
        minWidth: '200px',
        transition: 'all 0.3s ease',
        position: 'relative',
        overflow: 'hidden',
        cursor: 'pointer',
        backgroundColor: 'neutral.800'
      }}
      onClick={() => setCollection(isSelected ? '' : contractAddress)}
      _hover={{
        filter: 'brightness(120%)'
      }}
      data-group
    >
      <Box top={0}>
        <AspectRatio
          ratio={1}
          w="100%"
          pos="relative"
          overflow="hidden"
          minWidth={120}
          borderRadius="8px"
        >
          {data.metadata.image ? (
            <img
              src={data.metadata.image}
              alt={data.metadata.name?.toString() ?? ''}
            />
          ) : (
            <div>placeholder</div>
          )}
        </AspectRatio>
        <Text fontSize={14} fontWeight={500} mt={1} color="neutral.100">
          {name}
        </Text>
        <HStack alignItems="center" justifyContent="space-between" mt={1}>
          <Text fontSize={12} color="neutral.300">
            Floor
          </Text>
          <HStack alignItems="center" justifyContent="space-between" gap={2}>
            <Text fontSize={12} fontWeight={500} color="neutral.100">
              {floorPrice ? formatUSD.format(floorPrice) : '-'}
            </Text>
          </HStack>
        </HStack>
      </Box>
    </Box>
  );
};
